"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const iframe_1 = require("../../iframe");
class Redirector {
    redirect(redirectUrl, options) {
        if (options && options.handleRedirect) {
            options.handleRedirect(redirectUrl);
        }
        else if (options && options.redirectByReplacingState) {
            window.history.replaceState({}, "", redirectUrl);
        }
        else if (options === null || options === void 0 ? void 0 : options.redirectInIframe) {
            iframe_1.redirectInIframe(redirectUrl);
        }
        else {
            window.location.href = redirectUrl;
        }
    }
}
exports.default = Redirector;
//# sourceMappingURL=Redirector.js.map